module.exports = __webpack_public_path__ + "static/media/CT-20-CB.21017cf7.jpg";